export default __webpack_public_path__ + "95c96f47786c2adff44074418b24ef2b.png";